@if (joinApplyService.displayJoinApplyModal) {
  <div class="join-apply-modal" tabindex="-1" role="dialog">
    <div class="join-apply-modal-dialog" role="document">
      <div class="join-apply-modal-content">
        <div class="join-apply-modal-headers">
          <h4 class="join-apply-modal-title">{{ 'JoinApplyModalTitle' | translate }}</h4>
          <button
            type="button"
            class="join-apply-close"
            aria-label="Close"
            (click)="joinApplyService.closeJoinApplyModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="join-apply-modal-body">
          <div class="join-apply-table-wrap">
            <table class="join-apply-table">
              <thead>
                <tr>
                  <th class="join-apply-col-content">{{ 'JoinApplyContent' | translate }}</th>
                  <th class="join-apply-col-actions">{{ 'JoinApplyActions' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (item of joinApplyService.joinApplyRequests; track item.request_id + item.applicantId) {
                  <tr>
                    <td class="join-apply-message-cell">{{ getJoinApplyMessage(item) }}</td>
                    <td class="join-apply-actions-cell">
                      <button
                        nz-button
                        nzType="primary"
                        nzSize="small"
                        [disabled]="item.processing"
                        (click)="onApprove(item)">
                        {{ 'JoinApplyApprove' | translate }}
                      </button>
                      <button
                        nz-button
                        nzSize="small"
                        class="join-apply-reject-btn"
                        [disabled]="item.processing"
                        (click)="onReject(item)">
                        {{ 'JoinApplyReject' | translate }}
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
}
